// Module
var code = "<div id=\"searchautocomlete-component\"> <input type=\"text\" autocomplete-input options=\"$ctrl.options\" model=\"$ctrl.query\" submit=\"$ctrl.submit(match)\" select=\"$ctrl.select(match)\" spinner-id=\"$ctrl.spinnerId\" ng-model=\"$ctrl.query\" placeholder=\"{{ 'search' | t }}...\"/> </div> ";
// Exports
module.exports = code;